module.exports = __webpack_public_path__ + "img/unload-1-2.8c567cf2.png";